import { Section } from 'src/components/widgets/section';
import styled from 'styled-components';
import { SectionDelete } from './myAccountComponents';

export const CentralHeader = styled.div<{ $isFromSelectDates?: boolean }>`
    display: flex;
    justify-content: center;
    padding-top: ${(props) => (props.$isFromSelectDates ? '10px' : '20px')};
    label {
        font-size: 16px;
    }
`;

export const RightHeader = styled.div<{ $isFromSelectDates?: boolean }>`
    display: flex;
    justify-content: right;
    padding-top: ${(props) => (props.$isFromSelectDates ? '10px' : '20px')};
    label {
        font-size: 16px;
    }
`;

export const SectionPaymentShopify = styled(SectionDelete)`
    padding-bottom: 100px;
`;

export const RadiosContainer = styled.div`
    display: grid;
    gap: 50px;
    grid-template-columns: max-content max-content;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const InvoicesContainer = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
`;

export const SectionShopifyMessage = styled(Section)`
    padding-top: 30px;
    height: 100vh;
    div {
        height: auto;
    }
`;
